module.exports = __webpack_public_path__ + "static/media/footer.b4837e9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer.jpg
// module id = 297
// module chunks = 0